// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"318":"0587ca2d1ab14eba7c87","616":"384670e79e9e50423f63"}[chunkId] + ".js";
};